/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Community_Chip_ChannelsInputs */

const tr_landing_community_chip_channels = /** @type {(inputs: Landing_Community_Chip_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genel & kapalı kanallar`)
};

const en_landing_community_chip_channels = /** @type {(inputs: Landing_Community_Chip_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public & private channels`)
};

const de_landing_community_chip_channels = /** @type {(inputs: Landing_Community_Chip_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Öffentliche & geschlossene Kanäle`)
};

const ru_landing_community_chip_channels = /** @type {(inputs: Landing_Community_Chip_ChannelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открытые и закрытые каналы`)
};

/**
* | output |
* | --- |
* | "Public & private channels" |
*
* @param {Landing_Community_Chip_ChannelsInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_community_chip_channels = /** @type {((inputs?: Landing_Community_Chip_ChannelsInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Community_Chip_ChannelsInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_community_chip_channels(inputs)
	if (locale === "de") return de_landing_community_chip_channels(inputs)
	if (locale === "ru") return ru_landing_community_chip_channels(inputs)
	return tr_landing_community_chip_channels(inputs)
});